import { Route } from "react-router-dom";
import WalletScreen from "../../screens/WalletScreen";
import CreateProcessingPlant from "../../screens/land/CreateProcessingPlant";
import ProductRecipe from "../../screens/supply_chain/ProductRecipe";
import CreateProductRecipe from "../../screens/supply_chain/CreateProductRecipe";
import CreateBatch from "../../screens/supply_chain/CreateBatch";

export const processorRoutes = [
  <Route
    key="processor-processing-plants"
    path="/processing-plants"
    element={<WalletScreen walletType="PROCESSINGPLANTS" />}
  />,
  <Route
    key="processor-create-processing-plant"
    path="/create-processing-plant"
    element={<CreateProcessingPlant />}
  />,
  <Route
    key="processor-product-recipes"
    path="/product-recipes"
    element={<ProductRecipe walletType="RECIPES" />}
  />,
  <Route
    key="processor-create-product-recipe"
    path="/create-product-recipe"
    element={<CreateProductRecipe />}
  />,
  <Route
    key="processor-batches"
    path="/batches"
    element={<WalletScreen walletType="BATCHES" />}
  />,
  <Route
    key="processor-create-batch"
    path="/create-batch"
    element={<CreateBatch />}
  />,
];
